import * as React from 'react';
import { useSelector } from 'react-redux';
import formatGaugeRingData from '@utils/overview/gaugeRing';
import Chart from '@src/components/overview-dashboard/common/chart/Chart';
import humanizeUtil from '@utils/humanizeUtil';
import { currentMetricsMetaSelector } from '@src/store/common/selectors';
import {
  BLUE_COLOR,
  RED_COLOR,
  GOOD_SESSIONS_NUMBER_COLOR,
  SESSION_WIDGET_CONFIG,
} from './constants';
import {
  GoodSessionsWidgetWrapper,
  ImpactedSessionsWidgetWrapper,
  WidgetNumberWrapper,
  WidgetTextWrapper,
  WidgetTitle,
  WidgetSubscriptWrapper,
} from '../styled';

const getHumanizedValueString = (data, metricKey) => {
  const { humanizedNumber, humanizedUnit } = humanizeUtil(data[metricKey] || 0, metricKey);
  return `${humanizedNumber} ${humanizedUnit}`.trimEnd();
};

const SessionsWidget = ({
  data = {},
  selectedChartMetric,
  onWidgetCardClick: onBadSessionsGaugeClick,
}) => {
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const badSessionsMetric = SESSION_WIDGET_CONFIG.bad;
  const goodSessionsValue = getHumanizedValueString(data, SESSION_WIDGET_CONFIG.good);
  const badSessionsValue = getHumanizedValueString(data, badSessionsMetric);
  const badSessionsPctValue = data[SESSION_WIDGET_CONFIG.badRate];
  const goodSessionsAvgPlayDuration = getHumanizedValueString(
    data,
    SESSION_WIDGET_CONFIG.goodSecondary,
  );
  const badSessionsAvgPlayDuration = getHumanizedValueString(
    data,
    SESSION_WIDGET_CONFIG.badSecondary,
  );
  const renderGaugeRing = (data) => {
    const height = '60px';
    const width = '60px';
    const chartOption = formatGaugeRingData(
      [
        { value: 100 - data, name: 'Good Streams' },
        { value: data, name: 'Impacted Streams' },
      ],
      [BLUE_COLOR, RED_COLOR],
    );

    if (chartOption) {
      return <Chart option={chartOption} height={height} width={width} />;
    }
  };

  return (
    <>
      <GoodSessionsWidgetWrapper>
        {renderGaugeRing(badSessionsPctValue)}
        <WidgetTextWrapper>
          <WidgetTitle>{currentMetricsMeta[SESSION_WIDGET_CONFIG.good].displayName}</WidgetTitle>
          <WidgetNumberWrapper style={{ color: GOOD_SESSIONS_NUMBER_COLOR, display: 'flex' }}>
            {goodSessionsValue}
            {SESSION_WIDGET_CONFIG.goodSecondary && (
              <WidgetSubscriptWrapper>
                <span>{goodSessionsAvgPlayDuration}</span> {'Avg. Playing Time'}
              </WidgetSubscriptWrapper>
            )}
          </WidgetNumberWrapper>
        </WidgetTextWrapper>
      </GoodSessionsWidgetWrapper>

      <ImpactedSessionsWidgetWrapper
        onClick={() => onBadSessionsGaugeClick(badSessionsMetric, data?.[badSessionsMetric])}
        highlight={badSessionsMetric === selectedChartMetric}
      >
        <WidgetTextWrapper>
          <WidgetTitle>{currentMetricsMeta[badSessionsMetric].displayName}</WidgetTitle>
          <WidgetNumberWrapper style={{ color: RED_COLOR, display: 'flex' }}>
            {badSessionsValue}
            {SESSION_WIDGET_CONFIG.badSecondary && (
              <WidgetSubscriptWrapper>
                <span>{badSessionsAvgPlayDuration}</span> {'Avg. Playing Time'}
              </WidgetSubscriptWrapper>
            )}
          </WidgetNumberWrapper>
        </WidgetTextWrapper>
      </ImpactedSessionsWidgetWrapper>
    </>
  );
};

export default SessionsWidget;
